import React from "react";
import Select,  { PatternItem } from '../components/Select'
import CustomizerContext from "../CustomizerContext";
import { ChairBackShape } from '../ChairModel'
import { useSnapshot } from 'valtio'


const ChairBack = (props) => {
    
    const snap = useSnapshot(CustomizerContext)

    return(
        <div className="space-y-4 pt-4">
            <span className="font-bold">Chair back</span>
            
                <Select default={snap.chair.pattern} updateEvent={(shape) => {  CustomizerContext.chair.pattern = shape; }}>
                    <PatternItem value={ChairBackShape.heart} icon="heart" />
                    <PatternItem value={ChairBackShape.cloud} icon="cloud" />
                </Select>
        </div>
    )
}

export default ChairBack